import React, { PureComponent, Component } from 'react';
import CheckDefecto from '../../../../Common/Components/CheckDefecto'

class EntreDias extends Component {
    constructor(props) {
        super(props)
        this.state = {
            DiaInicio: props.data.calendario.DiaInicio,//props.data.proceso.Periodicidad == "EntreDias" ? props.data.calendario.DiaInicio : "",
            DiaFin: props.data.calendario.DiaFin
        };

        this.selectRadio = this.selectRadio.bind(this);

    }


    selectRadio(name, value) {
        this.props.selectRadio(name, value)

    }

    onChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        if ((regExp.test(value) || value.replace(/\s/g, "", "") == "")) {
            let newState = {
                [dataset.code]: value
            }
            this.setState(newState);
            this.props.changeInput(dataset.code, value);
        }
    }

    onBlur(event) {
        const { value, dataset } = event.target;
        
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            DiaInicio: nextProps.data.proceso.Periodicidad == "EntreDias" ? nextProps.data.calendario.DiaInicio : "",
            DiaFin: nextProps.data.proceso.Periodicidad == "EntreDias" ? nextProps.data.calendario.DiaFin : ""
        });
    }

    render() {

        const { proceso, calendario, ERROR_PROCESS } = this.props.data;

        return (
            <div className="row top-separator-xs" style={{marginLeft:"20px"}}>
                <div className="row">
                    <div className="col-xs-4">
                        <div className="row row-radio">
                            <div className="col-xs-10">
                                <div className="container-radio radio-margin" style={{marginLeft:"-7px"}}>
                                    <input id={"rbEntreDias" + 1}
                                        type="radio"
                                        name="rbEntreDias"
                                        data-value={"EntreDias"}
                                        value={true}
                                        checked={proceso.Periodicidad == "EntreDias"}
                                        onChange={(event) => this.selectRadio("Periodicidad", event.target.dataset.value)}
                                    />

                                    <label
                                        className="lbl-radio label-secondary"
                                        htmlFor={"rbEntreDias" + 1}>
                                        {"El primer día comprendido entre los días"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-1" style={{marginLeft:"-84px"}}>
                        <input className="form-control form-control-tarjetas input-Short"
                            maxLength={3}
                            value={this.state.DiaInicio}
                            data-code="DiaInicio"
                            data-validation="^([0-9]?\d|100)$"
                            disabled={proceso.Periodicidad != "EntreDias"}
                            onChange={this.onChange.bind(this)}
                            //onBlur={this.onBlur.bind(this)}
                        />
                    </div>
                    <div>
                    <label className="lbl-radio label-secondary" style={{marginLeft:"-5px", float:"left"}}>
                        y
                    </label>
                    </div>
                    <div className="col-xs-2" style={{marginLeft:"-9px"}}>
                        <input className="form-control form-control-tarjetas input-Short"
                            maxLength={3}
                            value={this.state.DiaFin}
                            data-code="DiaFin"
                            data-validation="^([0-9]?\d|100)$"
                            disabled={proceso.Periodicidad != "EntreDias"}
                            onChange={this.onChange.bind(this)}
                            //onBlur={this.onBlur.bind(this)}
                        />
                    </div>
                </div>

                <CheckDefecto 
                    style={{marginLeft:"19px"}}
                    nombre={"Solo días hábiles"}
                    referencia={"DiasHabiles" + 5}
                    id={"DiasHabiles" + 5}
                    activo={proceso.Periodicidad == "EntreDias"}
                    check={calendario.DiaHabil && proceso.Periodicidad == "EntreDias"}
                    selectCheckBox={(event) => this.props.setCheck("DiaHabil", event.target.checked)}
                />
                

                {!ERROR_PROCESS["seleccionoEntreDias"] && proceso.Periodicidad == "EntreDias" &&
                    <label className="error">{"Se deben de haber completado ambos campos con valores enteros entre 1 y 31, siendo el segundo valor mayor o igual que el primero."}</label>}

            </div >
        )
    }
};

export default EntreDias;